import { render, staticRenderFns } from "./HJ0020.vue?vue&type=template&id=18ac953c&scoped=true&"
import script from "./HJ0020.vue?vue&type=script&lang=js&"
export * from "./HJ0020.vue?vue&type=script&lang=js&"
import style0 from "./HJ0020.vue?vue&type=style&index=0&id=18ac953c&prod&lang=less&scoped=true&"
import style1 from "./HJ0020.vue?vue&type=style&index=1&id=18ac953c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ac953c",
  null
  
)

export default component.exports